module.exports = __webpack_public_path__ + "img/门店背景.ab4c05a1.png";